import ProductInlineBanner from '@/components/PIBanner';
import { useGlobal } from '@/utils/useGlobal';
import BackToTop from '@elem/compCommon/BackToTop';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import D_AU from './components/D_AU';
import E from './components/E';
import F from './components/F';
import F_NA from './components/F_NA';
import G from './components/G';
import G_AU from './components/G_AU';
import H from './components/H';
import J from './components/J';
import J_AU from './components/J_AU';
import JoinUs from './components/JoinUs';
import K from './components/K';
import K_NA from './components/K_NA';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import Power from './components/Power';
import Thumb from './components/Thumb';

const HIDE_BLOG_SITE = ['eu', 'kr'];

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [updateSolar, setUpdateSolar] = useState(null);
    const { t } = useLang('outdoorrecreation');
    const IS_NA = ['us', 'ca'].includes(locale);

    const obj: SideMenuProps = {
        items: IS_NA
            ? [
                {
                    text: t('secC_card1_title'),
                    link: '#outdoor-recreation-D',
                },
                {
                    text: t('secC_card2_title'),
                    link: '#outdoor-recreation-J',
                },
            ]
            : [
                { text: t('secC_list1_title'), link: '#outdoor-recreation-G' },
                { text: t('secC_list2_title'), link: '#outdoor-recreation-D' },
                { text: t('secC_list3_title'), link: '#outdoor-recreation-J' },
            ],
    };

    const getDynamicLinkBuy = (item): string => {
        let link = `https://${locale}.ecoflow.com/cart/`;
        if (item && item?.length > 0) {
            item?.map((sub, index) => {
                link += `${index === 0 ? '' : ','}${sub?.variantId}:${sub?.quantity || 1}`;
            });
        }
        link += `?channel=buy_button`;
        return link;
    };
    const handleAddCart = (data: any, isLink?: boolean) => {
        const cards = Array.isArray(data) ? data : [data];
        let result = JSON.parse(JSON.stringify(shoppingCarts));
        cards?.map((card: ShopifyCartItemType) => {
            const obj: ShopifyCartItemType = JSON.parse(JSON.stringify(card));
            if (card?.parentVariantId) {
                const target = result.find(
                    (item: ShopifyCartItemType) =>
                        item?.productId === card?.productId && item?.variantId === card?.variantId && item?.parentVariantId === card?.parentVariantId,
                );
                // 附属产品
                obj.quantity = Number(obj?.inventory) > 0 ? obj.quantity : 0;
                result = result.filter((item: ShopifyCartItemType) => !(item?.parentVariantId === card?.parentVariantId));
                if (target) {
                    result = [
                        obj,
                        ...result?.filter((item: any) => !(item?.variantId === target?.variantId && item?.parentVariantId === item?.parentVariantId)),
                    ];
                } else {
                    result = [obj, ...result];
                }
            } else {
                // 主产品
                const target = result.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
                if (target) {
                    obj.quantity = target.quantity;
                    result = [
                        obj,
                        ...result?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
                    ];
                } else {
                    obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
                    result = [obj, ...result];
                }
            }
        });
        if (isLink) {
            const link = getDynamicLinkBuy(cards)
            window.open(link, '_blank')
            return
        }

        setShoppingCarts(result);
        setVisible(true);
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean, target?: ShopifyCartItemType) => {
        setShoppingCarts(carts);
        if (isClose) {
            setVisible(false);
        }
        if (target) {
            setUpdateSolar(target);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const entry_position: any = {
        us: 12,
        ca: 12,
        au: 11,
        za: 9,
    };

    return (
        <>
            <B />
            {IS_NA && (
                <>
                    <Thumb />
                    <Power />
                </>
            )}
            {!IS_NA && <C />}
            {['au'].includes(locale) && (
                <>
                    <G_AU />
                    <H callBuy={handleAddCart} />
                </>
            )}
            {['au'].includes(locale) ? <D_AU /> : <D />}
            <E callBuy={handleAddCart} updateSolar={updateSolar} />
            {IS_NA && <ProductInlineBanner />}
            {!['kr'].includes(locale) && <F callBuy={handleAddCart} updateSolar={updateSolar} />}
            {!['us', 'ca', 'au', 'za'].includes(locale) && (
                <>
                    <G />
                    <H callBuy={handleAddCart} />
                </>
            )}
            {['au'].includes(locale) ? <J_AU /> : <J />}
            {IS_NA ? <K_NA callBuy={handleAddCart} /> : <K callBuy={handleAddCart} />}
            {['au'].includes(locale) && <JoinUs />}
            {IS_NA && <F_NA />}
            <EmailSubscribe
                locale={locale}
                className="email-subscribe"
                pageType={PAGE_TYPE.OutdoorRecreation}
                entry_position={entry_position[locale] || entry_position['us']}
            />
            {!['kr'].includes(locale) && <L />}
            <M />
            {!HIDE_BLOG_SITE.includes(locale) && <N />}
            <O />
            <h2 className="annotation">{t('secP')}</h2>
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.body)}
        </>
    );
}
